import $ from 'jquery';

import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { useEffect, useState } from "react";

import ic_call from '../assets/call.svg';
import ic_mail from '../assets/ic_mail.svg';

import logo from '../assets/logo.svg';
import cart from '../assets/Cart.svg';

export default function Header() {
    const [navbarToggle, setNavbarToggle] = useState(false);
    const toggleNavbar = () => {
      if (navbarToggle) $('#headerNavbar').addClass('collapse')
      else $('#headerNavbar').removeClass('collapse')

      setNavbarToggle(!navbarToggle)
    }


    return (
        <header className ="Header fixed-top">
            <ul className='d-flex small flex-row justify-content-end mb-0 py-2' 
            style={{ backgroundColor: '#1D1D1D', paddingRight: '30px' }}>
              <li className="me-5"><a className='fw-bold' href="tel:07002923784552"><img src={ic_call} width={12} className='me-2' />0700cybervilla</a></li>  
              <li><a href="mailto:support@cybervilla.io" className="fw-bold"><img src={ic_mail} width={12} className='me-2' />support@cybervilla.io</a></li>
            </ul>  
            <nav className="navbar mt-0 py-2 px-md-5 px-0 navbar-expand-lg bg-black">
              <div className="container-fluid px-3">
                <a className="navbar-brand" href="https://www.cybervilla.io">
                  <img src={logo} width="130"  alt="" />
                </a>
                <div className="navbar-toggler" onClick={() => toggleNavbar()} type="button" data-bs-target="#headerNavbar" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <div className="toggle-line t1 mb-1"></div>
                    <div className="toggle-line t2 mb-1"></div>
                    <div className="toggle-line t3 mb-1"></div>
                </div>


                <div class="collapse navbar-collapse " id="headerNavbar">
                  <ul class="navbar-nav mx-auto mb-2 mb-lg-0">
                    <li className="nav-item me-3 active " id="nav-item1" >
                            <Link to="https://cybervilla.io" className="nav-link" onClick={(e) => {
                                $('.nav-item').removeClass('active')
                                e.target.parentElement.classList.add('active')
                        }}>Home</Link>
                    </li>
                    <li className="nav-item me-3" id="nav-item2">
                            <Link className="nav-link" to="https://www.cybervilla.io/aboutus" onClick={(e) => {
                                $('.nav-item').removeClass('active')
                                e.target.parentElement.classList.add('active')
                        }}>About us</Link>
                        </li>
                        <li className="nav-item me-3 " id="nav-item3">
                            <Link  to="https://www.cybervilla.io/shop" className="nav-link" onClick={(e) => {
                                $('.nav-item').removeClass('active')
                                e.target.parentElement.classList.add('active')
                        }}>Products</Link>
                        </li>
                  </ul>
                </div>
              </div>
            </nav>
        </header>
    )
}